export function useSize(defaultWidth, defaultHeight, alignment, containerSize) {
    containerSize = containerSize !== null && containerSize !== void 0 ? containerSize : Infinity;
    let width = defaultWidth;
    let height = defaultHeight;
    const ratio = width / height;
    if (alignment !== 'center') {
        width = Math.min(defaultWidth / 3, +defaultWidth);
        if (defaultWidth > containerSize) {
            width = Math.min(containerSize / 3, +defaultWidth);
        }
        height = width / ratio;
    }
    // Keep within bounds
    if (width > containerSize) {
        width = containerSize;
    }
    return {
        width,
        height
    };
}

//# sourceMappingURL=useSize.js.map